import { useQuery } from '@tanstack/react-query';
import { IGetCandidateListPayload } from '../types';
import { PermanentJobsService } from '../services';

interface IUseGetCandidateListOptions {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

export const useGetCandidateList = (
  payload: IGetCandidateListPayload,
  options?: IUseGetCandidateListOptions,
) => {
  const limit = payload.limit || 10;
  const page = payload.page || 1;

  const { data, error, isFetching, isLoading, isError } = useQuery({
    initialData: {
      data: [],
      pagination: { page: 1, pageSize: 10, total: 0, totalPages: 1 },
      statistics: {
        tabs: {
          all: 0,
          app_expired: 0,
          applied: 0,
          cancelled: 0,
          hired: 0,
          interviewed: 0,
          rejected: 0,
          scheduled: 0,
        },
      },
    },
    queryKey: [
      'GET_CANDIDATE_LIST',
      payload.jobPostingId,
      limit,
      payload.orderBy,
      payload.orderDirection,
      page,
      payload.status,
    ],
    queryFn: async () =>
      PermanentJobsService.getCandidateList({
        ...payload,
        limit,
        page,
      }),
    retry: false,
    staleTime: 0,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? true,
  });

  return {
    ...data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
